"use strict"

import React from "react"
import {observer} from "mobx-react"
import {injectIntl} from "react-intl"

import {Container, Grid} from "@material-ui/core"

import Login from "./login"
import ForgotPassword from "./forgotPassword"
import XsPublicHeader from "../../global/ui/xsHeader/xsPublicHeader"

import LoginStore from "./loginStore"

function getScreen(screen) {
	switch (screen) {
		case LoginStore.screens.FORGOT:
			return <ForgotPassword />
		default:
			return <Login />
	}
}

function LoginContainer() {
	return (
		<React.Fragment>
			<XsPublicHeader />
			<Container maxWidth="lg">
				<Grid container justify="center">
					<Grid
						item
						style={{
							maxWidth: "450px",
							width: "450px"
						}}
					>
						<Grid container direction="column" justify="center" style={{height: "65vh"}}>
							{getScreen(LoginStore.screen)}
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</React.Fragment>
	)
}

export default injectIntl(observer(LoginContainer))

